import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  CustomerState,
  IInvoiceCustomer,
  InvoiceDeliveryType,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class InvoiceCustomer
  extends BaseModel<InvoiceCustomer, 'Customer'>
  implements IInvoiceCustomer
{
  static override readonly modelName: AbilitySubjectType = 'Customer';

  @Type(() => String)
  override id!: string;

  name?: string;

  surname?: string;

  fullname?: string;

  @Type(() => Date)
  birthDate?: Date | null;

  phone?: string;

  email?: string;

  invoicingEmail?: string;

  companyCustomer?: boolean;

  company?: string;

  companyId?: string;

  taxpayerId?: string;

  taxId?: string;

  invoicingCity?: string;

  invoicingDistrict?: string;

  invoicingStreet?: string;

  invoicingHouseNumber?: string;

  invoicingPostCode?: string;

  invoiceDelivery!: InvoiceDeliveryType;

  invoicingAddress?: string;

  hasCorrespondenceAddress?: boolean;

  correspondenceCity?: string;

  correspondenceDistrict?: string;

  correspondenceStreet?: string;

  correspondenceHouseNumber?: string;

  correspondencePostCode?: string;

  state?: CustomerState;

  tags?: string[];

  sipoNumber?: string;

  @Type(() => Date)
  invoiceFrom?: Date | null;
}
